import {
  Autocomplete,
  Box,
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import React from "react";

const ListApproval = ({ input }) => {
  return (
    <Box
      style={{
        px: 5,
        pb: 5,
        borderRadius: 10,
        display: "block",
        backgroundColor: "#fff",
      }}
    >
      <h3 style={{ textAlign: "center", paddingTop: 20 }}>
        LIST REVIEWER/APPROVAL
      </h3>
      <Table>
        <TableHead>
          <TableCell>Nama Pegawai</TableCell>
          <TableCell>Role</TableCell>
          <TableCell>Jabatan</TableCell>
          <TableCell>Status</TableCell>
          <TableCell>Verified Time</TableCell>
        </TableHead>
        <TableBody>
          {input.listApproval?.map((o, idx) => (
            <TableRow key={idx}>
              <>
                <TableCell>{o.displayName}</TableCell>
                <TableCell>{o.approvalRole}</TableCell>
                <TableCell>{o.jabatanUser}</TableCell>
                <TableCell>
                  {o.status ? (
                    <div
                      style={{
                        backgroundColor:
                          o.status.toLowerCase() === "verified" ||
                          o.status?.toLowerCase() === "issued"
                            ? "#92D050"
                            : "-",
                        borderRadius: "5px",
                        padding: "8px 0",
                        width: "100px",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                    >
                      {o.status}
                    </div>
                  ) : (
                    "-"
                  )}
                </TableCell>
                <TableCell>{o.reviewedAt ? o.reviewedAt : "-"}</TableCell>
              </>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default ListApproval;
